import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchPublicNewsletterIssue } from "../../api/newsletterApi";
import { NewsletterIssueBody } from "../../components/newsletter/NewsletterIssueBody";
import { formatIssueRange, usePingfloScoreboardFont } from "../../components/newsletter/newsletterFormat";
import "./PingfloNewsletterPage.css";

/** Login-free reading of one issue, reached through the signed link in the email. */
export default function PublicNewsletterPage() {
  const { issueId } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("t") || "";
  const { t, i18n } = useTranslation();
  const [issue, setIssue] = useState(null);
  const [error, setError] = useState("");
  usePingfloScoreboardFont();

  useEffect(() => {
    let cancelled = false;
    setError("");
    fetchPublicNewsletterIssue(issueId, token)
      .then((data) => {
        if (!cancelled) setIssue(data);
      })
      .catch(() => {
        if (!cancelled) setError(t("newsletterPublicMissing", "This issue link is not valid."));
      });
    return () => {
      cancelled = true;
    };
  }, [issueId, token, t]);

  const snapshot = issue?.snapshot || null;
  const signedIn = Boolean(localStorage.getItem("token"));

  return (
    <main className="pingflo-issue is-public">
      <header className="pingflo-mast">
        <div>
          <p className="pingflo-mark">Pingflo</p>
          <h1>{issue?.club_name || ""}</h1>
          {issue ? <p>{formatIssueRange(issue.start_date, issue.end_date, i18n.language)}</p> : null}
          {snapshot?.cycle?.group_names?.length ? (
            <p className="pingflo-groups">{snapshot.cycle.group_names.join(" · ")}</p>
          ) : null}
        </div>
      </header>
      {error ? <p className="pingflo-error">{error}</p> : null}
      {!issue && !error ? <p className="pingflo-empty">{t("loading", "Loading…")}</p> : null}
      {snapshot ? <NewsletterIssueBody snapshot={snapshot} /> : null}
      <p className="pingflo-public-foot">
        <Link to={signedIn ? `/newsletter/${encodeURIComponent(issueId)}` : "/login"}>
          {signedIn
            ? t("newsletterOpenInApp", "Open in the app")
            : t("newsletterSignIn", "Sign in to confirm your availability")}
        </Link>
      </p>
    </main>
  );
}
